// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";

export const mantinePieChartPropsSchema = z.object({
	h: z.number().optional(),
});
